import { c as _c } from "react/compiler-runtime";
import { DEFAULT_GROUPS_SORT_BY, GROUPS_SORT_BY_MAP, GROUPS_SORT_OPTIONS } from "@components/groups/groups-constants";
import { MembersSortBase } from "@components/table/members/members-sort-base";
import { getGroupsSortBy } from "@utils/group-utils";
import { getVisibleSortOptions } from "@utils/sort-utils";
/** Component to change the groups sort criteria for the tiles view */
export function GroupsSort(t0) {
  const $ = _c(8);
  const {
    sortBy,
    setSortBy,
    hiddenFields
  } = t0;
  let t1;
  if ($[0] !== hiddenFields) {
    t1 = new Set(hiddenFields);
    $[0] = hiddenFields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hiddenFieldsSet = t1;
  let t2;
  if ($[2] !== hiddenFieldsSet) {
    t2 = getVisibleSortOptions(GROUPS_SORT_OPTIONS, field => !hiddenFieldsSet.has(field));
    $[2] = hiddenFieldsSet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setSortBy || $[5] !== sortBy || $[6] !== t2) {
    t3 = <MembersSortBase sortBy={sortBy} setSortBy={setSortBy} sortOptions={t2} sortByMap={GROUPS_SORT_BY_MAP} defaultSortBy={DEFAULT_GROUPS_SORT_BY} getSortBy={getGroupsSortBy} subjectType="Group" />;
    $[4] = setSortBy;
    $[5] = sortBy;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}